// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Footer_wrap__7GkYx","menuObjects":"Footer_menuObjects__379HC","navElement":"Footer_navElement__rQ1aN","atag":"Footer_atag__29awL"};